<script>
	import { fly } from 'svelte/transition';
	import { cubicOut } from 'svelte/easing';
	import { onMount } from 'svelte';
	export let formId;
	export let label;
	export let disabled = false;
	export let auto = '';
	export let required = false;
	export let value = false;
	export let invalid = true;
	export let min = 0;
	export let max = 20;
	export let maxReason = max;
	let focused = false;

	const errorTransition = { y: -5, duration: 50, easing: cubicOut, delay: 0 };
	let validate = () => {
		if (required && !value && value != 0) {
			invalid = 'required - must be a number';
			return;
		} else if (required && value.length == 0) {
			invalid = 'required - must be a number';
			return;
		} else if (required && value < min) {
			invalid = `must be ${min} or greater`;
			return;
		} else if (required && value > max) {
			invalid = 'must be less than ' + maxReason;
			return;
		} else {
			invalid = false;
			return;
		}
	};
	onMount(() => {
		validate();
	});
</script>

<div class="formItem">
	<label class="form-label" class:inputInvalid={invalid && focused} for={formId}>{label}</label>
	<input
		class:inputInvalid={invalid && focused}
		{required}
		type="number"
		class="text-input"
		placeholder={label}
		name={formId}
		id={formId}
		bind:value
		autocomplete={auto}
		{disabled}
		on:input={() => {
			focused = true;
			validate();
		}}
		on:blur={validate}
	/>
	<div class="form-error-row">
		{#if invalid && focused}
			<p class="form-error" transition:fly={errorTransition}>{invalid}</p>
		{/if}
	</div>
</div>

<style>
	.formItem:not(:last-child) {
		margin-right: 1em;
	}
	.formItem {
		width: 75%;
	}
	input {
		width: 100%;
	}
	@media only screen and (max-width: 700px) {
		.formItem {
			width: 100%;
		}
	}
</style>
